<div class="ipm-side-nav" [ngClass]="{'ipm-sidenav--hidden': showSideNav}" ngClass.xs="ipm-side-nav--xs" ngClass.lt-lg="ipm-side-nav--lt-lg">
  <button class="ipm-side-nav__toggle" mat-icon-button (click)="toggleNavigation()" ngClass.lt-lg="ipm-side-nav__toggle--lt-lg">
    <app-svg-icon icon="icons-angle-double-right" classStyle="icon icon--olympus-blue"></app-svg-icon>
  </button>
</div>